$<template>
  <div class="container">
    <div class="row">
      <div class="col-12 mb-5 text-center">
        <h1>Tous vos devis</h1>
      </div>
    </div>
    <template v-if="quotes && quotes.length > 0">
      <template v-for="quote in quotes">
        <div
          v-for="subscription in getSubscriptionsQuoted(quote)"
          :key="subscription.id"
          class="col-12 mb-3"
        >
          <v-inline :quote="subscription" />
        </div>
      </template>
    </template>
    <v-no-resource v-else>
      <div class="d-flex flex-column">
        <div class="lead">
          Vous n’avez pas encore réalisé de nouveau devis.
        </div>
        <div class="lead">
          N’hésitez pas... soyez curieux !
        </div>
        <div class="mt-2">
          <a
            :href="getAppUrl('')"
            class="btn btn-primary fs-5 fw-bold"
          >
            <div class="d-flex flex-row mx-auto">
              <span class="me-1 my-auto">
                Nouveau devis
              </span>
              <v-icon icon="plus-white" />
            </div>
          </a>
        </div>
      </div>
    </v-no-resource>
  </div>
</template>
<script>
import { pick, get } from 'lodash-es';

import NoResource from '@/components/common/layout/DashboardNoResource.vue';
import InlineDisplay from '@/components/quote/QuoteDisplay.vue';

export default {
  name: 'ClientQuotes',
  components: {
    'v-no-resource': NoResource,
    'v-inline': InlineDisplay,
  },
  data() {
    return {
      placeholders: 2,
    };
  },
  computed: {
    orders() {
      return this.$store.getters['orders/get']
        .filter((order) => order.subscriptions)
        .map((order) => pick(order, ['subscriptions', 'id']));
    },
    quotes() {
      // A quote is a subscription with Affaire Nouvelle as a type
      // and quoted as a status.
      return this.orders.filter((order) => {
        const { subscriptions } = order;
        return (subscriptions.length === subscriptions
          .filter(({ type, status }) => type === 'AN' && status === 'QUOTED')
          .length);
      });
    },
  },
  beforeMount() {
    if (get(this, '$store.state.company.companyId')) {
      this.$store.dispatch('orders/setOrders',
        this.$store.state.company.companyId)
        .then(() => { setTimeout(() => { this.placeholders = 0 }, 600) });
    } else {
      setTimeout(() => { this.placeholders = 0 }, 600);
    }
  },
  methods: {
    goToQuote(quote) {
      window.location.assign(`${import.meta.env.VITE_WIDGET_URL}/edition?orderId=${quote.id}`);
    },
    getAppUrl(path) {
      return `${import.meta.env.VITE_WIDGET_URL}${path}`;
    },
    async removeSubscription(subscription) {
      await this.$store.dispatch('orders/remove', subscription);
      const companyId = get(this, '$store.state.company.companyId');
      // refresh orders
      if (companyId) {
        await this.$store.dispatch('orders/setOrders', companyId);
      }
    },
    getSubscriptionsQuoted({ subscriptions }) {
      return subscriptions.filter(({ status }) => status !== 'DRAFT');
    },
  },
};
</script>
